<template>
    <div>
        <div class="homeTop">
            <div class="homeTopBox">
                <div class="moduleBox" style="border-radius: 0px 0px 0px 0px;">
                    <div class="boxLayout" @click="handleNormalLoginEvent" >
                        <div class="leftMargin" >
                            <div  class="title">培训平台</div>
                            <!-- <div class="EnglishTitle" >Training Platform</div> -->
                        </div>                   
                        <img src="../../assets/img/newHome/icon-Traine.png" />
                        <div class="line"></div>
                    </div>
                </div>
                <div class="moduleBox" >
                    <div class="boxLayout" @click="handleAdminLoginEvent" >
                        <div class="leftMargin">
                            <div  class="title">信息发布</div>
                            <!-- <div class="EnglishTitle">Information Release</div> -->
                        </div>
                        
                        <img src="../../assets/img/newHome/icon-Info.png" />
                        <div  class="line"></div>
                    </div>       
                </div>
                <div class="moduleBox" >
                    <div class="boxLayout" @click="onRegister">
                        <div class="leftMargin">
                            <div class="title">在线咨询</div>
                            <!-- <div class="EnglishTitle">Online Consultation</div> -->
                        </div>
                        
                        <img src="../../assets/img/newHome/icon-ExpertDeclaration.png" />
                        <div  class="line"></div>
                    </div>

                </div>
                <div class="moduleBox">
                    <div class="boxLayout" @click="handleExpertLoginEvent">
                        <div class="leftMargin">
                            <div class="title">证书查询</div>
                            <!-- <div class="EnglishTitle">Certificate Query</div> -->
                        </div>
                        
                        <img src="../../assets/img/newHome/icon-ExpertLogin.png" />
                        <div  class="line"></div>
                    </div>
                </div>
                <div class="moduleBox" style="border-radius: 0px 0px 0px 0px;">
                    <div class="boxLayout" @click="handleMining" >
                        <div class="leftMargin">
                            <div class="title" >自采平台</div>
                            <!-- <div class="EnglishTitle">Self-sourced Platform</div> -->
                        </div>
                        
                        <img src="../../assets/img/newHome/icon-SelfPlatform.png" />
                        <div  class="line" style="background: #ffff;"></div>
                    </div>

                </div>
            </div>
        </div>
        <noticeAnnouncement :dynamicList="dynamicList" :informList="informList" :industryInfoList="industryInfoList"></noticeAnnouncement>
        <!-- <trainingArea></trainingArea> -->

        <!-- <div class="expertDeclaration">
            <div>
                <img src="../../assets/img/newHome/expertDeclaration.png" @click="onRegister" style="width:100%;cursor: pointer;" />
            </div>
        </div> -->
        <selfSourcingPublicity></selfSourcingPublicity>
        <policiesRegulations :policiesRegulations="policiesRegulations" :downloadItems="downloadItems"></policiesRegulations>
        
        <partyBuildingGarden :partyBuildings="partyBuildings" :aboutUsInfos="aboutUsInfos"></partyBuildingGarden>

        <el-dialog title="通知" :visible.sync="dialog_info_Visible" width="530px">
          <div>
            <el-button type="text" style="font-size: 20px;line-height: 33px; color: black;text-align: center;    width: 100%;white-space: pre-wrap;" onclick="window.open(`http://lngpa.cn/#/detail/d508cb99-b509-4388-9682-9f0720f40108`);">
                关于开展辽宁省政府采购从业人员线上培训的通知
            </el-button>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button plain size="small" @click="dialog_info_Visible = false">关  闭</el-button>
          </span>
        </el-dialog>
        <!-- <el-dialog title="通知" :visible.sync="dialog_info_Visible" width="530px">
          <div>
            <el-button type="text" style="font-size: 20px;line-height: 33px; color: black;text-align: center;    width: 100%;white-space: pre-wrap;" onclick="window.open(`http://lngpa.cn/#/detail/9eb7fbc2-9863-410b-b481-f76b45a3fd3a`);">
                关于辽宁省政府采购从业人员线上培训即将截止报名的通知
            </el-button>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button plain size="small" @click="dialog_info_Visible = false">关  闭</el-button>
          </span>
        </el-dialog> -->
        <!-- <memberStyle :showMembers="showMembers"></memberStyle> -->
    </div>
</template>
  
  <script>
    import * as dayjs from 'dayjs';
    import { prefixedUrlAsset } from '@/utils/constants';
    import noticeAnnouncement from './noticeAnnouncement.vue'
    import trainingArea from './trainingArea.vue'
    import selfSourcingPublicity from './selfSourcingPublicity.vue'
    import policiesRegulations from './policiesRegulations.vue'
    import partyBuildingGarden from './partyBuildingGarden.vue'
    import memberStyle from './memberStyle.vue'

  export default {
    name: 'Home',
    components: {
      noticeAnnouncement,
      trainingArea,
      selfSourcingPublicity,
      policiesRegulations,
      partyBuildingGarden,
      memberStyle,
    },
    computed: { },
    data() {
      return {
        banners2: [],
        tableData: [],
        associationDynamics: [], // 协会动态
        notifications: [], // 通知公告
        policiesRegulations: [], // 政策法规
        partyBuildings: [], // 党建园地
        integritySelfDisciplines: [], // 诚信自律
        aboutUsInfos: [], // 协会概况
        downloadItems: [], // 下载中心
        showMembers: [], // 会员风采
        dialog_info_Visible: true,
        dialog_img_Visible: true,
        pubInfoList: [],
        zixingloading: false,
        pageView: {},
        dynamicList:[],
        informList:[],
        industryInfoList:[],
      };
    },
    watch: {
      $route(newUrl, oldUrl) {
        console.log(newUrl, oldUrl);
      },
    },
    created() {
      this.axios.get(`${prefixedUrlAsset}/pub/news/list?pageNo=0&pageSize=10`).then((response) => {
        if (response.data.data) {
            response.data.data.map((item) => {
                if (item.catalog.name === '协会动态') {
                    // eslint-disable-next-line no-shadow
                    let result = item.newsList;
                    if (item.newsList && item.newsList.length >8) {
                        result = item.newsList.slice(0, 8)
                    }

                    this.dynamicList = result.map((item) => ({
                        createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
                        title: item.title,
                        id: item.id,
                    }));
                }
                if (item.catalog.name === '通知公告') {
                    let result = item.newsList;
                    if (item.newsList && item.newsList.length > 8) {
                        result = item.newsList.slice(0, 8)
                    }
                    this.informList = result.map((item) => ({
                        createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
                        title: item.title,
                        id: item.id,
                    }));
                }

                if (item.catalog.name === '行业资讯') {
                    let result = item.newsList;
                    if (item.newsList && item.newsList.length >8) {
                        result = item.newsList.slice(0, 8)
                    }
                    this.industryInfoList = result.map((item) => ({
                        createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
                        title: item.title,
                        id: item.id,
                    }));
                }

                if (item.catalog.name === '政策法规') {
                    let result = item.newsList;
                    if (item.newsList && item.newsList.length > 7) {
                        result = item.newsList.slice(0, 7)
                    }
                    this.policiesRegulations = result.map((item) => ({
                        createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
                        title: item.title,
                        id: item.id,
                    }));
                }
                if (item.catalog.name === '下载中心') {
                    this.downloadItems = item.newsList.map((item) => ({
                      createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
                      title: item.title,
                      id: item.id,
                    }));
                }

                if (item.catalog.name === '党建园地') {
                    let result = item.newsList;
                    if (item.newsList && item.newsList.length > 7) {
                        result = item.newsList.slice(0, 7)
                    }
                    this.partyBuildings = result.map((item) => ({
                        createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
                        title: item.title,
                        id: item.id,
                    }));
                }
                if (item.catalog.name === '加入协会') {
                  this.aboutUsInfos = item.newsList.map((item) => ({
                    createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
                    title: item.title,
                    id: item.id,
                  }));
                }
                if (item.catalog.name === '会员风采') {
            
                    this.showMembers = item.newsList.map((item) => ({
                        createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
                        title: item.title,
                        id: item.id,
                        picUrl: item.picUrl
                    }));
                    
                }
            
            });
        }
        });
    },
    mounted() {
      //this.getPubInfoList();
    },
    methods: {
      //专家注册
      onRegister() {
        // this.$router.push('/register');
        window.open(`/#/onlinelist`);
      },
      onMore() {
        this.$router.push('/publicity');
      },
      renderDate(val) {
        return dayjs(val).format('YYYY-MM-DD')
      },
      getPubInfoList() {
        this.zixingloading = true;
        this.axios.post(`${prefixedUrlAsset}/api/pubInfomation/getPubInfoList`, {current: 1, rowCount: 10}).then((({ data })=> {
          this.zixingloading = false;
          if (data.code == 200) {
            this.pubInfoList = data.data.data;
          }
        }))
      },
      //自采平台跳转
      handleMining(){
        // window.open(`/#/platform`);
        window.open('http://121.37.101.193:9011/');
      },
      //培训平台
      handleNormalLoginEvent() {
        // window.open('http://localhost:8002/gpassoc-user/#/login');
        window.open('/gpassoc-user/#/login');
      },
      //信息发布
      handleAdminLoginEvent() {
        // window.open('http://localhost:8007/#/login');
        window.open('/gpassoc-admin/#/login');
      },
      //专家登录
      handleExpertLoginEvent() {
        // window.open('http://localhost:8007/#/login');
        //window.open('/gpassoc-admin/#/zjLogin');
        window.open(`/#/certificate`);
      },
    },
  };
  </script>
    <style lang="less">
        .homeTop{
            width: 100%;
            //height: 300px;
            // background-image:  url("~@/assets/img/newHome/tdln.png");
            // background-repeat: no-repeat;
            // background-size: 100% 300px ;
            background: #F5F5F5;
            .homeTopBox{
                padding: 20px 10% 0 10%;
                display: flex;
                .moduleBox{
                    flex: 1;
                    height: 80px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    cursor: pointer;
                    .boxLayout{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 100%;
                        .leftMargin{
                            margin-left: 30px;
                            .title{
                                font-weight: bold;
                                font-size: 16px;
                                color: #000000;
                            }
                            .EnglishTitle{
                                font-weight: bold;
                                font-size: 12px;
                                color: #9AA6B5;
                            }
                            
                        }
                        .line{
                            width: 2px;
                            height: 40px;
                            background: #CBECE6;
                        }
                    }
                }
            }
        }
        .expertDeclaration{
            padding: 40px 10%;
            background: #00A287;
        }
    </style>
    <style lang="scss">
        body {
            margin: 0;
        }
        .specialMain .main {
            display: none;
        }

        /*轮播图图片样式*/
        .banner-img {
            width: 100%;
            height: 458px;
        }
    </style>
    <style>
    
.el-dialog {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
 
.el-dialog__header {
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #018745;
}
 
.el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}
 
.el-dialog__body {
  padding: 30px 20px;
  color: #666;
}
 
.el-dialog__footer {
  padding: 10px 20px 20px;
  border-top: 1px solid #f0f0f0;
  text-align: right;
}


    </style>
  